import { defineStore } from "pinia";

import walletService from "../../service/wallets/wallet.service";
import { Transfer } from "../../service/wallets/interface/wallet.interface";

const walletStore = defineStore("wallet", {
  state: () => ({
      chartInfo: {
          salary: Array(12).fill(0) as number[],
          taxes: Array(12).fill(0) as number[],
          pension: Array(12).fill(0) as number[],
          health: Array(12).fill(0) as number[],
      },
      updatedChartInfo: {
          salary: Array(12).fill(0) as number[],
          taxes: Array(12).fill(0) as number[],
          pension: Array(12).fill(0) as number[],
          health: Array(12).fill(0) as number[],
      },
      totalAmount: 0,
      totalPaymentsThisYear: 0,
      totalSalaryThisYear: 0,
      totalTaxesThisYear: 0,
      totalPensionThisYear: 0,
      totalHealthThisYear: 0,
      totalSalaryDisbursedPercentage: 0,
      totalTaxesDisbursedPercentage: 0,
      totalPensionDisbursedPercentage: 0,
      totalHealthDisbursedPercentage: 0,
      years: [],
  }),
getters: {
  getYear(): any {
    // Implement your getter logic here if needed
  },
  chartData(): any {
    return {
      labels: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      datasets: [
        {
          label: "Salary",
          data: this.updatedChartInfo.salary,
          borderColor: "#0D2D22",
          backgroundColor: "rgba(13, 45, 34, 0.18)",
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: "#0D2D22",
          pointHoverBorderColor: "#fff",
          pointHoverBorderWidth: 2,
        },
        {
          label: "Taxes",
          data: this.updatedChartInfo.taxes,
          borderColor: "#7AAB78",
          backgroundColor: "rgba(122, 171, 120, 0.18)",
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: "#7AAB78",
          pointHoverBorderColor: "#fff",
          pointHoverBorderWidth: 2,
        },
        {
          label: "Pension",
          data: this.updatedChartInfo.pension,
          borderColor: "#D9A441",
          backgroundColor: "rgba(217, 164, 65, 0.18)",
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: "#D9A441",
          pointHoverBorderColor: "#fff",
          pointHoverBorderWidth: 2,
        },
        {
          label: "Health",
          data: this.updatedChartInfo.health,
          borderColor: "#B3554A",
          backgroundColor: "rgba(179, 85, 74, 0.18)",
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
          pointHoverRadius: 6,
          pointHoverBackgroundColor: "#B3554A",
          pointHoverBorderColor: "#fff",
          pointHoverBorderWidth: 2,
        },
      ],
    }
  }
},
actions: {
  chartOptions(isDark: boolean): any {
    return {
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          backgroundColor: "#0D2D22",
          titleColor: "#FFFFFF",
          bodyColor: "#DDEADC",
          padding: 10,
          cornerRadius: 8,
          displayColors: true,
          boxPadding: 4,
          callbacks: {
            label(context: any) {
              const value = context.raw as number;
              if (value >= 1_000_000) return `${context.dataset.label}: ₦${(value / 1_000_000).toFixed(2)}M`;
              if (value >= 1_000) return `${context.dataset.label}: ₦${(value / 1_000).toFixed(1)}k`;
              return `${context.dataset.label}: ₦${value}`;
            },
          },
        },
      },
      interaction: {
        mode: 'index',
        intersect: false,
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            // color: "rgba(34, 34, 34, 0.38)",
            color: isDark ? "#FFFFFF61" : "rgba(34, 34, 34, 0.38)",
          },
        },
        y: {
          grid: {
            color: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(13, 45, 34, 0.1)",
            lineWidth: 1,
          },
          border: {
            dash: [8, 10],
            dashOffset: 4,
            color: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(13, 45, 34, 0.1)",
          },
          ticks: {
            callback: function (value: number) {
              if (value >= 1_000_000) return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
              if (value >= 1_000) return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
              return value;
            },
            color: isDark ? "#FFFFFF61" : "rgba(34, 34, 34, 0.38)",
          },
        },
      },
    }
  },

  async getBanks(): Promise<any> {
    try {
      const response = await walletService.getBanks();
      if (response.data) {
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message);
      }
    } catch (error: any) {
      return await Promise.reject(error);
    }
  },
  async createWallet(userId: number): Promise<any> {
    try {
      const response = await walletService.createWallet(userId);
      console.log("Wallet >>>>", response)
      return response;
    } catch (error) {
      console.error("Error creating wallet:", error);
      throw error;
    }
  },

  async getWallet(userId: number): Promise<any> {
    try {
      const response = await walletService.getWallet(userId);
      if (response.data) {
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message);
      }
    } catch (error: any) {
      console.error("Error fetching wallet:", error.response ? error.response.data : error.message);
      return await Promise.reject(error);
    }
  },
  async transfer(data: Transfer): Promise<any> {
    try {
      const response = await walletService.transfer(data);
      if (response.data) {
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message);
      }
    } catch (error: any) {
      return await Promise.reject(error);
    }
  },
  // async create(): Promise<any> {
  //   try {
  //     const response = await walletService.createWallet();
  //     if (response.data) {
  //       return await Promise.resolve(response);
  //     } else if (response.response) {
  //       return await Promise.reject(response.response);
  //     } else {
  //       return await Promise.reject(response.message);
  //     }
  //   } catch (error: any) {
  //     return await Promise.reject(error);
  //   }
  // },

  async getWalletHistory(): Promise<any> {
    try {
      const response = await walletService.getWalletHistory();
      if (response.data) {
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message);
      }
    } catch (error: any) {
      return await Promise.reject(error);
    }
  },

  async getChartYears(): Promise<any> {
    try {
      const response = await walletService.getChartYears();
      if (response.data) {
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message);
      }
    } catch (error: any) {
      return await Promise.reject(error);
    }
  },

  async getChartDetail(chartYear: number): Promise<any> {
    try {
      const response = await walletService.getChartData(chartYear);
      if (response.data) {
        return await Promise.resolve(response);
      } else if (response.response) {
        return await Promise.reject(response.response);
      } else {
        return await Promise.reject(response.message);
      }
    } catch (error: any) {
      return await Promise.reject(error);
    }
  },

  async getTransactionHistory(year: number, organisationId: number): Promise<any> {
    const response = await walletService.getTransactionHistory(organisationId, year);
    console.log("Transaction history response:", response);
    return response.data?.data ?? null;
  },

  async initChart(data: any): Promise<any> {
    const histories = data?.payrollHistories ?? [];
    this.chartInfo.salary = histories.map((h: any) => h.salary ?? 0);
    this.chartInfo.taxes = histories.map((h: any) => h.tax ?? 0);
    this.chartInfo.pension = histories.map((h: any) => h.pension ?? 0);
    this.chartInfo.health = histories.map((h: any) => h.health ?? 0);
    this.updatedChartInfo.salary = this.chartInfo.salary;
    this.updatedChartInfo.taxes = this.chartInfo.taxes;
    this.updatedChartInfo.pension = this.chartInfo.pension;
    this.updatedChartInfo.health = this.chartInfo.health;
    this.totalSalaryThisYear = data?.totalSalaryDisbursed ?? 0;
    this.totalTaxesThisYear = data?.totalTaxesDisbursed ?? 0;
    this.totalPensionThisYear = data?.totalPensionDisbursed ?? 0;
    this.totalHealthThisYear = data?.totalHealthDisbursed ?? 0;
    this.totalSalaryDisbursedPercentage = data?.totalSalaryDisbursedPercentage ?? 0;
    this.totalTaxesDisbursedPercentage = data?.totalTaxesDisbursedPercentage ?? 0;
    this.totalPensionDisbursedPercentage = data?.totalPensionDisbursedPercentage ?? 0;
    this.totalHealthDisbursedPercentage = data?.totalHealthDisbursedPercentage ?? 0;
    this.totalPaymentsThisYear = data?.totalPayment ?? 0;
  },
  async updateChart(data: any): Promise<any> {
    await this.initChart(data);
  }
},
});

export default walletStore;
